// src/core/productsApi.js
import { axiosClient } from "./axiosClient";


/**
 * PRODUCTS API
 * Public:
 *  - GET /products/
 *  - GET /products/dropdown/
 *
 * Admin (JWT staff):
 *  - POST /products/
 *  - PATCH /products/{id}/
 *  - DELETE /products/{id}/   (soft delete)
 */

// Public
export const getProductsPublic = async () => {
  const res = await axiosClient.get("/products/");
  return res.data;
};

export const getProductsDropdown = async () => {
  const res = await axiosClient.get("/products/dropdown/");
  return res.data;
};

// Admin
const buildProductFormData = (payload, coverImageFile = null) => {
  const fd = new FormData();

  // IMPORTANT:
  // features is array. For multipart, most DRF setups accept JSON string.
  // If your backend expects repeated fields like features[]=a,features[]=b, adjust here.
  const normalized = {
    ...payload,
    features: Array.isArray(payload.features) ? payload.features : [],
  };

  Object.entries(normalized).forEach(([key, value]) => {
    if (value === undefined || value === null) return;

    if (key === "features") {
      fd.append("features", JSON.stringify(value));
      return;
    }

    if (typeof value === "boolean") {
      fd.append(key, value ? "true" : "false");
      return;
    }

    fd.append(key, String(value));
  });

  if (coverImageFile) {
    fd.append("cover_image", coverImageFile);
  }

  return fd;
};

export const createProductAdmin = async (payload, coverImageFile = null) => {
  const formData = buildProductFormData(payload, coverImageFile);
  const res = await axiosClient.post("/products/", formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });
  return res.data;
};

export const updateProductAdmin = async (id, payload, coverImageFile = null) => {
  const formData = buildProductFormData(payload, coverImageFile);
  const res = await axiosClient.patch(`/products/${id}/`, formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });
  return res.data;
};

export const deleteProductAdmin = async (id) => {
  const res = await axiosClient.delete(`/products/${id}/`);
  return res.data;
};
